import { VStack } from '@chakra-ui/react';
import { MdCode } from 'react-icons/md';
import CredentialsAPI from '../components/CredentialsAPI';
import PixelConfigure from '../components/PixelConfigure';
import SectionCard from './SectionCard';

export default function IntegrationsTab() {
  return (
    <VStack
      spacing={4}
      align="stretch"
    >
      <CredentialsAPI />

      <SectionCard
        title="Configuração de Pixel"
        icon={MdCode}
      >
        <PixelConfigure />
      </SectionCard>
    </VStack>
  );
}
